import ConditionalTooltip from "components/Reusable/ConditionalTooltip/ConditionalTooltip.tsx";
import { LinkToNewTab } from "components/Elements/Link/Link";
import { useContent } from "contexts/contentContext/contentContext";
import { plansObj } from "../Utils/Lists";
import { useUser } from "contexts/userContext/userContext";

interface CardPlanButtonI {
  sysName: string;
  isYearly: boolean;
  tableButton: boolean | undefined;
  couponCode?: string | number;
}

const CardPlanButton = ({
  sysName,
  isYearly,
  tableButton,
  couponCode,
}: CardPlanButtonI) => {
  const { getUserData, isLoggedIn } = useUser();
  const { getTextByKey } = useContent();

  if (sysName === "enterprise") {
    return (
      <div className="card-plans-button">
        <LinkToNewTab
          page="contact-us?subject=sales"
          classes="jm-button new-button blank-button"
        >
          {getTextByKey("contact-us").toUpperCase()}
        </LinkToNewTab>
      </div>
    );
  }

  return (
    <div className="card-plans-button">
      {sysName !== "free" ? (
        <ConditionalTooltip
          tooltipTextKey="sub-user-select-plan-tooltip"
          condition={getUserData().IsSubUser}
        >
          <LinkToNewTab
            page={`${
              isYearly
                ? plansObj[sysName].linkYearly
                : plansObj[sysName].linkMonthly
            }${couponCode && isYearly ? "?coupon=" + couponCode : ""}`}
            classes={`jm-button new-button${
              getUserData().IsSubUser ? " disabled" : ""
            }`}
          >
            {`${getTextByKey(tableButton ? "select" : "choose-plan")} ${
              tableButton ? sysName : ""
            }`}
          </LinkToNewTab>
        </ConditionalTooltip>
      ) : (
        <LinkToNewTab
          page={"registration"}
          classes={`jm-button new-button${isLoggedIn() ? " disabled" : ""}`}
        >
          {getTextByKey("create-account")}
        </LinkToNewTab>
      )}
    </div>
  );
};

export default CardPlanButton;
